import { Form, Input, Button, Col, Row } from 'antd'
import { useTranslation } from 'react-i18next'

export function LoginForm({ onForgotPassword, onSubmit }) {
  const { t } = useTranslation()

  return (
    <Form layout="vertical" onFinish={onSubmit} requiredMark={false}>
      <Form.Item
        label={t('Login.ExistingEmail')}
        name="email"
        htmlFor="login-email"
        rules={[
          {
            required: true,
            message: t('Login.error.PleaseEnterEmail'),
          },
          {
            type: 'email',
            message: t('Register.error.PleaseEnterValidEmail'),
          },
        ]}
      >
        <Input
          tabIndex={1}
          id="login-email"
          autoComplete="username"
          placeholder=""
        />
      </Form.Item>

      <Form.Item
        label={t('Login.ExistingPassword')}
        htmlFor="login-password"
        name="password"
        rules={[
          {
            required: true,
            message: t('Login.error.PleaseEnterPassword'),
          },
        ]}
        style={{ marginBottom: 10 }}
      >
        <Input.Password
          tabIndex={2}
          id="login-password"
          autoComplete="current-password"
          placeholder=""
        />
      </Form.Item>

      <Row justify="space-between">
        <Col xs={24} sm={14} xl={12}>
          <Button
            tabIndex={3}
            type="primary"
            htmlType="submit"
            block
            size="large"
            className="login-button-no-padding"
          >
            {t('Login.Login')}
          </Button>
        </Col>
        <Col style={{ display: 'flex', alignItems: 'flex-start' }}>
          <Button
            className="login-form-forgot"
            type="link"
            onClick={onForgotPassword}
            style={{ padding: 0, height: 'auto' }}
          >
            {t('Login.ForgotPassword')}
          </Button>
        </Col>
      </Row>
    </Form>
  )
}
export default LoginForm